export const MESSAGE_LIST_CSS = /* css */ `
  /* ── Messages ── */
  .lk-widget-messages {
    flex: 1; overflow-y: auto; overflow-x: hidden; padding: 20px 0;
    display: flex; flex-direction: column; gap: 0;
    min-height: 320px;
    /* Keep overscroll inside the list and suppress the bounce: without this,
       flicking past the top or bottom edge chains out to the WKWebView's own
       scroll view and rubber-bands the whole embed instead of just the chat. */
    overscroll-behavior: none;
  }
  .lk-widget-messages::-webkit-scrollbar { width: 4px; }
  .lk-widget-messages::-webkit-scrollbar-thumb { background: var(--wg-border); border-radius: 2px; }

  .lk-widget-msg {
    word-break: break-word; font-size: 13px; line-height: 1.3;
    letter-spacing: 0.13px; font-weight: 500;
  }

  /* ── User messages (right-aligned, dark green bubble) ── */
  .lk-widget-msg--user {
    display: flex; flex-direction: column; align-items: flex-end;
    padding: 7px 10px 7px 65px;
  }
  .lk-widget-msg--user .lk-widget-msg-bubble {
    background: var(--wg-msg-bubble); color: white;
    border-radius: 10px 10px 0 10px;
    padding: 10px 15px; max-width: 290px; text-align: right;
  }

  /* Row wrapper for initials chip next to user bubble. */
  .lk-widget-msg-row {
    display: flex; align-items: flex-end; gap: 8px;
  }
  .lk-widget-msg-initials {
    flex-shrink: 0;
    width: 28px; height: 28px; border-radius: 50%;
    background: rgba(54, 209, 191, 0.5); color: var(--wg-fg);
    display: flex; align-items: center; justify-content: center;
    font-size: 11px; font-weight: 700; letter-spacing: 0.2px;
    user-select: none;
  }

  /* ── Agent messages (left-aligned, beige bubble + avatar) ── */
  .lk-widget-msg--agent {
    display: flex; flex-direction: column; align-items: flex-start;
    padding: 7px 15px;
  }
  .lk-widget-msg-agent-row {
    display: flex; align-items: flex-end; gap: 10px; width: 100%;
  }
  .lk-widget-msg-agent-avatar {
    flex-shrink: 0; width: 34px; height: 34px; border-radius: 50%;
    border: 1.6px solid white;
    /* background-image (set inline) paints instantly from cache on every mount;
       the brand color holds the circle so it never flashes blank. */
    background-color: var(--wg-star-filled);
    background-size: cover; background-position: center; background-repeat: no-repeat;
  }
  .lk-widget-msg-agent-bubble {
    flex: 0 1 auto; min-width: 0; max-width: 290px;
    background: var(--wg-msg-bubble-agent); color: var(--wg-fg);
    border-radius: 8px 8px 8px 0;
    padding: 10px;
  }

  /* ── "Courtney is thinking" typing indicator ── */
  .lk-widget-thinking {
    display: inline-flex; align-items: center; gap: 4px;
    min-height: 18px;
    animation: lk-fade-in 0.18s ease;
  }
  @keyframes lk-fade-in { from { opacity: 0; } to { opacity: 1; } }
  .lk-thinking-dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: var(--wg-card-fg-muted, #8a94a3);
    animation: lk-thinking-bounce 1.2s ease-in-out infinite;
  }
  .lk-thinking-dot:nth-child(2) { animation-delay: 0.15s; }
  .lk-thinking-dot:nth-child(3) { animation-delay: 0.3s; }
  @keyframes lk-thinking-bounce {
    0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
    30% { transform: translateY(-4px); opacity: 1; }
  }

  /* ── Tool-result cards (standalone, no bubble/avatar) ── */
  .lk-widget-msg--card {
    padding: 7px 14px 14px 12px;
  }

  /* ── Connecting indicator ── */
  .lk-widget-connecting {
    padding: 12px 15px; color: var(--wg-fg-muted); font-style: italic; font-size: 13px;
  }

  /* ── Mobile: messages flow bottom-to-top ──
     On phones the newest message sits just above the input and older messages
     stack upward (like a native chat app), so a short conversation isn't
     stranded at the top of a tall screen. margin-top:auto on the first row
     pushes content to the bottom when there's spare room, and collapses to 0
     once the list overflows so the full history stays scrollable. We also drop
     the 320px min-height floor so the list can shrink to fit above the keyboard.
     Desktop keeps the default top-to-bottom fill. */
  @media (max-width: 768px) {
    .lk-widget-messages {
      min-height: 0;
    }
    .lk-widget-messages > :first-child {
      margin-top: auto;
    }
  }
`;
